// Register Quill's inline-STYLE attributors so font/size/color/align are emitted
// as portable inline CSS (renders in the learner view without Quill's stylesheet).
// Safe to call repeatedly and where window.Quill isn't present.
export function registerQuillStyleAttributors() {
  if (typeof window === 'undefined' || !window.Quill) return;
  try {
    ['align', 'font', 'size', 'color', 'background'].forEach((key) => {
      window.Quill.register(window.Quill.import(`attributors/style/${key}`), true);
    });
  } catch (_e) {
    /* no-op */
  }
}
